export default function Apiurl() {
  // const apiurl = "http://127.0.0.1:8000/api/";
  const apiurl = "https://studibreeze.in/backend/api/";
  // const apiurl = "https://rishispectre.pythonanywhere.com/api/";

  return apiurl;
}
